"use client";

import Link from "next/link";
import { useSession } from "@/lib/auth-client";
import styles from "./auth.module.css";

/**
 * Client-side so the pages it sits above stay statically rendered. It is
 * display only — every protected route re-checks the session on the server.
 */
export default function AuthNav() {
  const { data: session, isPending } = useSession();

  return (
    <nav className={styles.nav}>
      <Link className={styles.brand} href="/">
        SiteOfPurple
      </Link>
      <div className={styles.navLinks}>
        {isPending ? null : session ? (
          <Link href="/account">{session.user.name || session.user.email}</Link>
        ) : (
          <>
            <Link href="/sign-in">Log in</Link>
            <Link href="/sign-up">Register</Link>
          </>
        )}
      </div>
    </nav>
  );
}
